import { render, staticRenderFns } from "./DataTableCollapse.vue?vue&type=template&id=b2ee68ba&scoped=true"
import script from "./DataTableCollapse.vue?vue&type=script&lang=js"
export * from "./DataTableCollapse.vue?vue&type=script&lang=js"
import style0 from "./DataTableCollapse.vue?vue&type=style&index=0&id=b2ee68ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ee68ba",
  null
  
)

export default component.exports